'use client';

import React from 'react';
import Link from 'next/link';
import GeneralSection from '@/components/seo/GeneralSection';
import CitySearch from './RankingCitySearch';
import ListOptions from './ListOptions';
import LinksContainer from '@/components/seo/LinksContainer';
import { renameL1Name } from '@/utils/job-ranking';
import { RankingPageProps } from '@/types/job-ranking';
import { OptionType } from '@/types/common';
import { HOT_LEVEL } from '@/constants/job-ranking';
import {
  JOB_RANKING_PAGE_ROUTER_PATH,
  RANK_TOP_POST_PAGE_ROUTER_PATH,
  RANK_TOP_SALARY_PAGE_ROUTER_PATH,
} from '@/constants/router-path';

const RecommendALink = React.memo(
  (props: { isOpenJob?: boolean; l1Data: OptionType }) => {
    const { isOpenJob, l1Data } = props;
    const name = `${l1Data.id === HOT_LEVEL.id ? l1Data.name : renameL1Name(l1Data.id, l1Data.name)}${
      isOpenJob ? '职位发布趋势排名' : '职位薪资排名'
    }`;

    return (
      <li className="mt-6">
        <Link
          href={
            JOB_RANKING_PAGE_ROUTER_PATH +
            l1Data.id +
            `${isOpenJob ? RANK_TOP_POST_PAGE_ROUTER_PATH : RANK_TOP_SALARY_PAGE_ROUTER_PATH}`
          }
          className="line-clamp-1 hover:underline"
          title={name}
        >
          {name}
        </Link>
      </li>
    );
  },
);

const RankingPage = (props: RankingPageProps) => {
  const {
    rankData: { location, salary_rank, open_job_rank, exist_locations },
    filterId,
    l1Data,
    recommendL1Data,
    seoHotLinks,
    isOpenJob,
  } = props;

  return (
    <GeneralSection
      marginTop="mt-12"
      rightComponent={
        <div className="p-6 rounded-lg bg-web-grey-400 my-10">
          <span className="text-xl font-semibold">推荐</span>
          <ul className="list-none !ml-0 text-sm font-semibold">
            <RecommendALink isOpenJob={!isOpenJob} l1Data={l1Data} />
            {l1Data.id !== HOT_LEVEL.id && (
              <>
                <RecommendALink
                  isOpenJob={isOpenJob}
                  l1Data={{ id: HOT_LEVEL.id, name: HOT_LEVEL.aliaName }}
                />
                <RecommendALink
                  isOpenJob={!isOpenJob}
                  l1Data={{ id: HOT_LEVEL.id, name: HOT_LEVEL.aliaName }}
                />
              </>
            )}
            {recommendL1Data.map((item) => (
              <React.Fragment key={item.id}>
                <RecommendALink isOpenJob={isOpenJob} l1Data={item} />
                <RecommendALink isOpenJob={!isOpenJob} l1Data={item} />
              </React.Fragment>
            ))}
          </ul>
        </div>
      }
    >
      <div className="flex items-center justify-between">
        <h2 className="text-3.25xl leading-14 font-semibold mr-6">
          {`${location?.name || ''}${renameL1Name(filterId, l1Data.name)}职位${
            isOpenJob ? '发布趋势' : '薪资收入'
          }排名`}
        </h2>
        <CitySearch
          options={exist_locations}
          location={location}
          filterId={filterId}
        />
      </div>
      {isOpenJob ? (
        <ListOptions
          options={open_job_rank}
          location={location}
          filterId={filterId}
          isOpenJob={true}
          margin="my-8"
          padding="py-0"
          border="border-none"
        />
      ) : (
        <ListOptions
          options={salary_rank}
          location={location}
          filterId={filterId}
          padding="py-0"
          border="border-none"
          margin="my-8"
        />
      )}
      <LinksContainer seoHotLinks={seoHotLinks} city={location} />
    </GeneralSection>
  );
};

export default RankingPage;
